import { Injectable } from '@angular/core';
import { LastSuccessfulSynchronizationItem } from 'src/app/shared/local-db/models/last-successful-synchronization';
import { SynchronizationCheckpoint } from 'src/app/shared/local-db/models/synchronization-checkpoint';
import { SynchronizationCheckpointRepository } from 'src/app/shared/local-db/repositories/synchronization-checkpoint.repository';

@Injectable({
  providedIn: 'root',
})
export class SynchronizationCheckpointService {
  constructor(
    private readonly synchronizationCheckpointRepository: SynchronizationCheckpointRepository
  ) {}

  async getCheckpoint(userEmail: string): Promise<SynchronizationCheckpoint | undefined> {
    return await this.synchronizationCheckpointRepository.getByUserEmail(userEmail);
  }

  async saveCheckpoint(
    userEmail: string,
    items: LastSuccessfulSynchronizationItem[],
    startedAt?: Date
  ): Promise<void> {
    const currentCheckpoint = await this.getCheckpoint(userEmail);
    const checkpoint = new SynchronizationCheckpoint({
      userEmail,
      startedAt: startedAt ?? currentCheckpoint?.startedAt ?? new Date(),
      updatedAt: new Date(),
      items,
    });

    await this.synchronizationCheckpointRepository.save(checkpoint);
  }

  async clearCheckpoint(userEmail: string): Promise<void> {
    await this.synchronizationCheckpointRepository.delete(userEmail);
  }
}
